import React from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { Button } from './ui/Button';
import { StarIcon } from 'lucide-react';
export function LastChance() {
  const {
    lastChance,
    global
  } = pageData;
  return <section className="py-24 px-4 bg-navy-900 border-t border-white/5 relative overflow-hidden" data-id="element-101">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[300px] bg-gold-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-102" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-103">
        <h2 className="text-4xl md:text-6xl mb-6" data-id="element-104">{lastChance.heading}</h2>
        <p className="text-lg text-slate-400 mb-12 max-w-xl mx-auto" data-id="element-105">
          {lastChance.subheading}
        </p>

        <div className="bg-slate-850 border border-slate-800 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-106">
          <h3 className="font-display text-2xl md:text-3xl text-white mb-2" data-id="element-107">
            {global.productName}
          </h3>
          <div className="text-gold-500 font-bold tracking-widest uppercase text-sm mb-6" data-id="element-108">
            6 VOLUMES + 5 BONUSES
          </div>

          <div className="text-slate-400 line-through text-lg mb-1" data-id="element-109">
            Regular Price: {global.currency} {global.originalPrice}
          </div>
          <div className="text-gold-500 font-bold tracking-widest uppercase text-xs mb-1" data-id="element-110">
            TODAY ONLY
          </div>
          <div className="text-5xl md:text-6xl font-display text-white mb-8" data-id="element-111">
            {global.currency} {global.price}
          </div>

          <Button className="mb-6" onClick={() => {
          window.location.href = global.checkoutUrl;
        }} data-id="element-112">
            {lastChance.ctaText}
          </Button>

          <div className="flex items-center justify-center gap-2" data-id="element-113">
            <div className="flex text-gold-500" data-id="element-114">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-115" />)}
            </div>
            <span className="text-sm text-slate-400 font-medium" data-id="element-116">
              500+ Coaches trust this system
            </span>
          </div>
        </div>
      </div>
    </section>;
}